import { translationUploadData_sv_part1 } from "./translationUploadData.sv.part1";
import { defineTranslationTree } from "./translationTypes";
import { translationUploadData_sv_part2 } from "./translationUploadData.sv.part2";
import { translationUploadData_sv_part3 } from "./translationUploadData.sv.part3";
import { translationUploadData_sv_part4 } from "./translationUploadData.sv.part4";

export const translationUploadData_sv = defineTranslationTree({
  ...translationUploadData_sv_part1,
  ...translationUploadData_sv_part2,
  ...translationUploadData_sv_part3,
  ...translationUploadData_sv_part4,
});
